import {
  LeftToRightListBulletIcon,
  CursorTextIcon,
  Calendar04Icon,
  AttachmentIcon,
  TextFontIcon,
  ToggleOnIcon,
  RadioButtonIcon,
  Location01Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { QuestionType } from "api/landlord-surveys/types/questions";

const iconMap: Record<QuestionType, typeof TextFontIcon> = {
  [QuestionType.LONG_TEXT]: CursorTextIcon,
  [QuestionType.YES_NO]: ToggleOnIcon,
  [QuestionType.CHECKBOX_MULTI]: LeftToRightListBulletIcon,
  [QuestionType.RADIO_GROUP]: RadioButtonIcon,
  [QuestionType.DATE]: Calendar04Icon,
  [QuestionType.FILE_SINGLE]: AttachmentIcon,
  [QuestionType.ADDRESS]: Location01Icon
};

export const IconMap = ({
  type,
  className
}: {
  type: QuestionType;
  className?: string;
}) => (
  <HugeiconsIcon
    icon={iconMap[type]}
    size={20}
    strokeWidth={1.5}
    className={className || "text-content-1000"}
  />
);
